module.exports = __webpack_public_path__ + "static/media/twitch.a734a864.svg";